import { PRODUCT_KEYS } from '../productKeys/ProductKeys';
import { TRY_MODE } from '../Utils/Utils';

export const getApiEndpoint = (currentProduct, mode, activeTab) => {
  let apiEndpoint = currentProduct.apiEndpoint;
  if (mode === TRY_MODE.DUAL) {
    switch (currentProduct.productKey) {
      case PRODUCT_KEYS.PASSPORT_OCR:
        if (activeTab === 'front') {
          apiEndpoint = `${apiEndpoint}/passport/front`;
        } else if (activeTab === 'back') {
          apiEndpoint = `${apiEndpoint}/passport/back`;
        }
        break;

      case PRODUCT_KEYS.AADHAAR_OCR:
        if (activeTab === 'front') {
          apiEndpoint = `${apiEndpoint}/aadhaar/front`;
        } else if (activeTab === 'back') {
          apiEndpoint = `${apiEndpoint}/aadhaar/back`;
        }
        break;

      case PRODUCT_KEYS.EMIRATES_ID_OCR:
        if (activeTab === 'front') {
          apiEndpoint = `${apiEndpoint}/emiratesId/front`;
        } else if (activeTab === 'back') {
          apiEndpoint = `${apiEndpoint}/emiratesId/back`;
        }
        break;

      case PRODUCT_KEYS.VOTER_ID_OCR:
        if (activeTab === 'front') {
          apiEndpoint = `${apiEndpoint}/voter-id/front`;
        } else if (activeTab === 'back') {
          apiEndpoint = `${apiEndpoint}/voter-id/back`;
        }
        break;

      case PRODUCT_KEYS.MEXICAN_ID_OCR:
        if (activeTab === 'front') {
          apiEndpoint = `${apiEndpoint}/mexicanVoterId/front`;
        } else if (activeTab === 'back') {
          apiEndpoint = `${apiEndpoint}/mexicanVoterId/back`;
        }
        break;

      default:
        if (activeTab === 'front') {
          apiEndpoint = `${apiEndpoint}/front`;
        } else if (activeTab === 'back') {
          apiEndpoint = `${apiEndpoint}/back`;
        }
        break;
    }
  } else {
    switch (currentProduct.productKey) {
      case PRODUCT_KEYS.PAN_CARD_OCR:
        apiEndpoint = `${apiEndpoint}/pan1`;
        break;

      case PRODUCT_KEYS.AADHAAR_MASK:
        apiEndpoint = `${apiEndpoint}/api/v7/aadharMask`;
        break;

      case PRODUCT_KEYS.MALAYSIAN_VOTER_ID_OCR:
        apiEndpoint = `${apiEndpoint}/MalaysianId`;
        break;

      case PRODUCT_KEYS.MALAYSIAN_DRIVING_LICENSE_OCR:
        apiEndpoint = `${apiEndpoint}/MalaysianDL`;
        break;

      case PRODUCT_KEYS.UAE_VISA_OCR:
        apiEndpoint = `${apiEndpoint}/UAEVisa`;
        break;

      default:
        apiEndpoint = `${apiEndpoint}/process`;
        break;
    }
  }

  return apiEndpoint;
};
